import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@material-ui/core';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import HttpService from '../services/httpService';
import { useSelector } from 'react-redux';
import moment from 'moment'
import '../App.css';

const ScanPackageReports = (props) => {
    const { userDetails } = useSelector((state) => state.user);
    const [packageDetails, setPackageDetails] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const retrievePackageDetails = async () => {
        try {
            const response = await HttpService.getProjectWiseReports(userDetails._id);

            setPackageDetails(response.data.projects || []);
        } catch (error) {
            console.error('Error fetching package reports:', error);
        }
    };

    const handlePackageStatus = async (el, info) => {
        try {
            const obj = {
                status: info,
                project_id: el.projectNo
            };
            const getStatusWiseData = await HttpService.getStatusWiseData(obj);


            // Open dialog and set selected project data
            setSelectedProject(getStatusWiseData.data);
            setDialogOpen(true);
        } catch (error) {
            console.error('Error fetching status wise data:', error);
        }
    };

    useEffect(() => {
        retrievePackageDetails();
    }, []);

    return (
        <>
            <Typography variant="h6" style={{ marginBottom: '1rem', textAlign: 'center' }}>
                Project-wise Package Scan Report
            </Typography>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">S.No</TableCell>
                            <TableCell align="center">P.No</TableCell>
                            <TableCell align="center">Material Delivery Date</TableCell>
                            <TableCell align="center">Total Pkg Count</TableCell>
                            <TableCell align="center">Scanned Pkg Count</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {packageDetails.map((el, i) => (
                            <TableRow key={i}>
                                <TableCell align="center">{i + 1}</TableCell>
                                <TableCell align="center">{el.projectNo}</TableCell>
                                <TableCell align="center">
                                    {el.materialDeliveryDate
                                        ? new Date(el.materialDeliveryDate).toLocaleDateString()
                                        : 'Not Delivered'}
                                </TableCell>
                                <TableCell
                                    onClick={() => handlePackageStatus(el, 'total')}
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    align="center"
                                >
                                    {el.totalPackages}
                                </TableCell>
                                <TableCell
                                    onClick={() => handlePackageStatus(el, 'scanned')}
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    align="center"
                                >
                                    {el.scannedPackages}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Dialog box with table inside */}
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle style={{ textAlign: 'center' }}>Package Details</DialogTitle>
                <DialogContent>
                    {selectedProject && selectedProject.packages && selectedProject.packages.length > 0 ? (
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">S.No</TableCell>
                                        <TableCell align="center">Project Name</TableCell>
                                        <TableCell align="center">Package Name</TableCell>
                                        <TableCell align="center">Assigned User</TableCell>
                                        <TableCell align="center">Scanned By</TableCell>
                                        <TableCell align="center">Scanned Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedProject.packages
                                        .sort((a, b) => {
                                            // Sort by scan status: unscanned (false) first, then scanned (true)
                                            const aIsScanned = a.users && a.users.length > 0;
                                            const bIsScanned = b.users && b.users.length > 0;

                                            if (aIsScanned === bIsScanned) return 0;
                                            return aIsScanned ? 1 : -1; // Unscanned comes first
                                        })
                                        .map((pkg, index) => (
                                            <TableRow
                                                key={pkg.packageId}
                                                style={{
                                                    backgroundColor: pkg.users && pkg.users.length > 0
                                                        ? '#e8f5e8'
                                                        : '#ffe6e6'
                                                }}
                                            >
                                                <TableCell align="center">{index + 1}</TableCell>
                                                <TableCell align="center">{pkg.project_id}</TableCell>
                                                <TableCell align="center">{pkg.package_name}</TableCell>
                                                <TableCell align="center">
                                                    {pkg.created_by ? pkg.created_by.name : 'N/A'}
                                                </TableCell>
                                                <TableCell align="center" style={{
                                                    color: pkg.users && pkg.users.length > 0 ? '#006600' : '#cc0000',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {pkg.users && pkg.users.length > 0
                                                        ? pkg.users.map((user) => user.name).join(', ')
                                                        : 'Not Scanned'}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {pkg?.processedAt ? moment(pkg?.processedAt).format('DD-MM-YYYY') : "NA"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography align="center" style={{ marginTop: '1rem' }}>
                            No package details available.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(ScanPackageReports);